import React, { useState } from 'react';
import I18n from '@/modules/i18n';
import Icon from '@/components/ui/Icon';
import Pill from '@/components/ui/Pill';
import Checkbox from '@/components/common/libraries/common/Checkbox/Checkbox';
import cn from '@/utils/cn';
import { IAssignmentTypeFilterOption } from '../../types';
import { getCheckboxState, getSelectedChildCount } from './selectionUtils';

interface AssignmentTypeTreeNodeProps {
  option: IAssignmentTypeFilterOption;
  selected: string[];
  onToggle: (option: IAssignmentTypeFilterOption) => void;
}

const AssignmentTypeTreeNode = ({ option, selected, onToggle }: AssignmentTypeTreeNodeProps) => {
  const [expanded, setExpanded] = useState(false);
  const checkboxState = getCheckboxState(option, selected);
  const selectedChildCount = getSelectedChildCount(option, selected);

  return (
    <div>
      <div className="tw-flex tw-items-center tw-justify-between tw-py-1.5">
        <Checkbox
          shouldCover
          checked={checkboxState === 'checked'}
          indeterminate={checkboxState === 'indeterminate'}
          label={option.label}
          onChange={() => onToggle(option)}
        />
        <div className="tw-flex tw-items-center tw-gap-2">
          {selectedChildCount > 0 && (
            <Pill pillClassName="tw-text-xs" pillColor="purple">
              {I18n.t('n_selected', { count: selectedChildCount })}
            </Pill>
          )}
          {option.children && (
            <button
              aria-expanded={expanded}
              aria-label={expanded
                ? `${I18n.t('collapse')} ${option.label}` : `${I18n.t('expand')} ${option.label}`}
              className="tw-flex tw-bg-transparent tw-border-0 tw-p-0 tw-cursor-pointer"
              type="button"
              onClick={() => setExpanded(!expanded)}
            >
              <Icon
                className={cn('tw-transition-transform', { '-tw-rotate-90': !expanded })}
                icon="ChevronDown"
                size={12}
              />
            </button>
          )}
        </div>
      </div>

      {option.children && expanded && (
        <div className="tw-pl-6">
          {option.children.map(child => (
            <AssignmentTypeTreeNode
              key={child.value}
              option={child}
              selected={selected}
              onToggle={onToggle}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default AssignmentTypeTreeNode;
